import { render } from "./Playground.vue?vue&type=template&id=06ed3e58&scoped=true"
import script from "./Playground.vue?vue&type=script&lang=js"
export * from "./Playground.vue?vue&type=script&lang=js"

import "./Playground.vue?vue&type=style&index=0&id=06ed3e58&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server-spice/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ed3e58"]])

export default __exports__